module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery1-9f7a96b5948306fc4870acb0a9ebb77f.png";